/**
 * Professional Academy — gedeelde stijl & rekenregels (expertportaal, Netflix-stijl).
 *
 * Rijkleur (hover-gloed) per hoofdmap komt van de API (hoofdmap_kleur):
 *  1 Welzijn = groen, 2 Trauma = rood, 3 PSA = paars, 4 Arbo = donkerblauw,
 *  5 Ontwikkeling = lichtblauw, 6 Passie = WKR-oranje.
 */
import { Laptop, Landmark, BookOpen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ProLeervorm, ProTraining } from '../../services/professionalAcademyApi';

export const eur = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

/** "€ 300,-" voor ronde bedragen, anders "€ 142,50". */
export function prijs(bedrag: number): string {
  return Number.isInteger(bedrag) ? `${eur.format(bedrag).replace(/,00$/, '')},-` : eur.format(bedrag);
}

export const WKR_ORANJE = '#FF9800';

export const LEERVORM: Record<ProLeervorm, { label: string; icon: LucideIcon; badge: string }> = {
  e_learning: { label: 'E-Learning', icon: Laptop, badge: 'bg-blue-600 shadow-blue-900/40' },
  workshop: { label: 'Workshop', icon: Landmark, badge: 'bg-emerald-600 shadow-emerald-900/40' },
  opleiding: { label: 'Opleiding', icon: BookOpen, badge: 'bg-violet-600 shadow-violet-900/40' },
};

export function accentVoor(t: Pick<ProTraining, 'hoofdmap_kleur' | 'passie'>): string {
  return t.passie ? WKR_ORANJE : t.hoofdmap_kleur;
}

export function datumKort(iso: string): string {
  return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
}

/** "Donderdag 12-11-2026" */
export function datumLang(iso: string): string {
  const d = new Date(iso);
  const dag = d.toLocaleDateString('nl-NL', { weekday: 'long' });
  const datum = d.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return `${dag.charAt(0).toUpperCase()}${dag.slice(1)} ${datum}`;
}

export function tijd(iso: string): string {
  return new Date(iso).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
}

export function pePunten(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toLocaleString('nl-NL', { maximumFractionDigits: 1 });
}
